import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as sessionActions from "../../../actions/sessionActions";
import { throwException } from "../../../actions/exceptionActions";
import LinkOverzichtForm from "./LinkOverzichtForm";
import IdentificatieCodeEditForm from "./IdentificatieCodeEditForm";
import LinkAddForm from "./LinkAddForm";
import redirector from "../../../util/redirector";
import LinkOverzichtPageHelper from "./LinkOverzichtPageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import Section from "../../common/Section";
import * as types from "../../../constants/ComponentConstants";
import { getSession } from "../../../store/configureStore";
import * as DomainConstants from '../../../constants/DomainConstants';

class LinkOverzichtPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            addMode: false,
            editMode: false,
            transactieId: '',
            models: [],
            originalModels: [],
            searchModels: [],
            shouldScrollToFirstError: false,
            undoButtonDisabled: true,
            sporttakFilter: null,
            relatieType: -1,
            typeFilter: 1,
            naamFilter: "",
            naamFilterHasFocus: false,
            showLinkChecks: false,
            identificatieCodeChanged: false,
            checkboxStatussen: {
                showLidVanSportraad: false,
                showErkendDoor: false,
                showGesubsidieerdDoor: false,
                lidVanSportraad: false,
                erkendDoorSportdienst: false,
                gesubsidieerdDoorOverheidsinst: false,
                originalLidVanSportraad: false,
                originalErkendDoorSportdienst: false,
                originalGesubsidieerdDoorOverheidsinst: false
            }
        };

        this.pageHelper = new LinkOverzichtPageHelper(this, redirector);
    }

    handleOnUndo = () => this.pageHelper.undo();
    handleOnAdd = () => this.pageHelper.add();
    handleOnEditIdentificatieCode = (organisatieId) => this.pageHelper.handleOnEditIdentificatieCode(organisatieId);
    handleOnCancelAdd = () => this.pageHelper.cancelAdd();
    handleOnContinueAdd = () => this.pageHelper.continueAdd();
    handleOnCancelEdit = () => this.pageHelper.cancelEdit();
    handleOnContinueEdit = () => this.pageHelper.continueEdit();
    handleOnSave = () => this.pageHelper.save();
    handleOnChangeAddFilter = (event) => this.pageHelper.changeAddFilter(event);
    handleOnChangeIdentificatieCode = (event) => this.pageHelper.changeIdentificatieCode(event);
    onChangeOverzichtCheckbox = (e) => this.pageHelper.onChangeOverzichtCheckbox(e);
    handleOnSearch = () => this.pageHelper.search();
    handleOnChangeToAdd = (event) => this.pageHelper.changeToAdd(event);
    handleOnChangeLinksCheck = (event) => this.pageHelper.onChangeLinksCheck(event);

    componentDidMount = () => {
        this.props.setHasUnsavedChanges(false);
        super.componentDidMount();
        this.pageHelper.init();
    };

    render() {
        const state = this.state;
        const { addMode, searchModels, naamFilterHasFocus, editMode } = state;
        const models = state.models;
        const disabled = this.props.disabled;
        const isNew = this.props.isNew;
        const federatieNaam = this.props.federatieNaam;
        const federatieId = this.props.federatieId;
        return <Section
            title={"Links / relaties"}
            color={types.COLOR_BLUE}
        >
            {addMode ?
                <LinkAddForm
                    onCancel={this.handleOnCancelAdd}
                    onContinue={this.handleOnContinueAdd}
                    orgTypes={this.props.orgTypes}
                    sporttakken={this.props.sporttakken}
                    typeFilter={this.state.typeFilter}
                    relatieType={this.state.relatieType}
                    naamFilter={this.state.naamFilter}
                    sporttakFilter={this.state.sporttakFilter}
                    onChangeFilter={this.handleOnChangeAddFilter}
                    onSearch={this.handleOnSearch}
                    searchModels={searchModels}
                    onChangeToAdd={this.handleOnChangeToAdd}
                    models={models}
                    errors={state.errors}
                    sportVlaanderenRoot={this.props.sportVlaanderenRoot}
                    naamFilterHasFocus={naamFilterHasFocus}
                    userType={this.props.userType}
                /> : editMode ? 
                <IdentificatieCodeEditForm 
                    onCancel={this.handleOnCancelEdit}
                    onContinue={this.handleOnContinueEdit}
                    organisatie={this.state.editingOrganisatie}
                    errors={state.errors}
                    onChangeIdentificatieCode={this.handleOnChangeIdentificatieCode}
                /> :
                <LinkOverzichtForm
                    models={models}
                    disabled={disabled}
                    isNew={isNew}
                    federatieNaam={federatieNaam}
                    federatieId={federatieId}
                    sportVlaanderenRoot={this.props.sportVlaanderenRoot}
                    onChange={this.onChangeOverzichtCheckbox}
                    onChangeLinksCheck={this.handleOnChangeLinksCheck}
                    onUndo={this.handleOnUndo}
                    onAdd={this.handleOnAdd}
                    onEditIdentificatieCode={this.handleOnEditIdentificatieCode}
                    onSave={this.handleOnSave}
                    undoButtonDisabled={this.state.undoButtonDisabled}
                    userType={this.props.userType}
                    checkboxStatussen={state.checkboxStatussen}
                    showLinkChecks={state.showLinkChecks}
                    identificatieCodeChanged={state.identificatieCodeChanged}
                />}
        </Section>;
    }
}

LinkOverzichtPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        federatieOndernemingsnummer: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.ondernemingsnummer: null,
        federatieId: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.id: null,
        federatieNaam: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.naam: null,
        gebruikersnaam: state.security.currentUser,
        userType: state.session.userType,
        transactieId: state.session.activeTransactionId,
        disabled: state.session.readOnly,
        isNew: state.session.isNew,
        sporttakken: state.referentie.sporttakken,
        orgTypes: state.referentie.orgTypesForSportclubParent,
        sportVlaanderenRoot: state.settings.sportVlaanderenRoot
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
        setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch),
        enableNav: bindActionCreators(layoutActions.enableTopNav, dispatch),
        disableNav: bindActionCreators(layoutActions.disableTopNav, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkOverzichtPage);